function Rules() {
  const rules = [
    "Students must arrive 5 minutes before school time and attend assembly.",
    "Proper school uniform must be worn at all times.",
    "Maintain discipline and good conduct in school.",
    "Foul language and bullying are strictly prohibited.",
    "Respect teachers, peers, juniors, and staff.",
    "School property must not be damaged.",
    "Do not bring valuables like watches, ornaments, or expensive items.",
    "School is not responsible for lost items.",
    "Avoid bringing mobile phones and vehicles without license.",
    "Students with contagious diseases must submit medical clearance.",
    "Parents must take prior appointment to meet staff.",
    "Parents should regularly monitor student progress and diary.",
  ];

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">

        <h1 className="text-4xl font-bold text-blue-900 mb-10 text-center">
          School Rules & Regulations
        </h1>

        <div className="bg-white p-8 rounded-2xl shadow">
          <ul className="space-y-4 text-gray-700">
            {rules.map((rule, i) => (
              <li key={i}>✔ {rule}</li>
            ))}
          </ul>
        </div>

      </div>
    </section>
  );
}

export default Rules;